import React, { Component, } from 'react'
import PropTypes from 'prop-types'
import deepmerge from 'deepmerge'

import zoomDoctor from 'lib/zoomDoctor'
import GoogleMap from 'components/GoogleMaps/Map'
import CustomMarker from 'components/CustomMarker'
import ZoomControls from 'components/ZoomControls'

import './styles.css'

class Map extends Component {
  static propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    events: PropTypes.array,
    onEventSelected: PropTypes.func,
    centerLatLng: PropTypes.shape({
      lat: PropTypes.number,
      lng: PropTypes.number,
    }),
    currentEventId: PropTypes.string,
    setup: PropTypes.shape({
      disableDefaultUI: PropTypes.bool,
      defaultCenterUserLocation: PropTypes.bool,
      defaultCenter: PropTypes.shape({
        lat: PropTypes.number,
        lng: PropTypes.number,
      }),
      initialZoom: PropTypes.number,
      minZoom: PropTypes.number,
      showZoomControls: PropTypes.bool,
      showLatLng: PropTypes.bool,
      // eslint-disable-next-line react/forbid-prop-types
      mapStyle: PropTypes.object,
    }),
  }

  static defaultProps = {
    events: [],
    onEventSelected: () => {},
    centerLatLng: undefined,
    currentEventId: undefined,
    setup: {
      disableDefaultUI: true,
      defaultCenterUserLocation: false,
      defaultCenter: { lat: 13.62058, lng: -51.414341, },
      initialZoom: 2,
      minZoom: 1,
      showZoomControls: true,
      showLatLng: false,
      mapStyle: {
        position: 'absolute',
        top: '0px',
        right: '0px',
        bottom: '0px',
        left: '0px',
        backgroundColor: '#a3ccff',
      },
    },
  }

  state = {}

  componentDidMount() {
    zoomDoctor.init()
  }

  zoomIn = () => {
    this.setState({
      setZoom: {
        timestamp: new Date().getTime(),
        mode: 'zoomIn',
      },
    })
  }

  zoomOut = () => {
    this.setState({
      setZoom: {
        timestamp: new Date().getTime(),
        mode: 'zoomOut',
      },
    })
  }

  zoomTo = (value) => {
    this.setState({
      setZoom: {
        timestamp: new Date().getTime(),
        mode: 'value',
        value,
      },
    })
  }

  render() {
    const { zoomIn, zoomOut, } = this
    const { setZoom, } = this.state
    const { events, setup, onEventSelected, centerLatLng, currentEventId } = this.props

    const mergedSetup = deepmerge(this.constructor.defaultProps.setup, setup)
    const panTo = centerLatLng
      ? { lat: centerLatLng.lat, lng: centerLatLng.lng, }
      : undefined

    const initialCenter = centerLatLng || mergedSetup.defaultCenter
    const initialCenterUserLocation = centerLatLng
      ? false
      : mergedSetup.defaultCenterUserLocation

    return (
      <div data-component="Map" className="Map">
        {mergedSetup.showZoomControls &&
          <ZoomControls zoomIn={zoomIn} zoomOut={zoomOut} />}
        <GoogleMap
          disableDefaultUI={mergedSetup.disableDefaultUI}
          minZoom={mergedSetup.minZoom}
          style={mergedSetup.mapStyle}
          showLatLng={mergedSetup.showLatLng}
          initialZoom={mergedSetup.initialZoom}
          initialCenterUserLocation={initialCenterUserLocation}
          initialCenter={initialCenter}
          events={events}
          currentEventId={currentEventId}
          markerSelected={onEventSelected}
          customMarker={CustomMarker}
          panTo={panTo}
          setZoom={setZoom}
          ref={(c) => {
            this.map = c
          }}
        />
      </div>
    )
  }
}

export default Map



// WEBPACK FOOTER //
// ./src/components/Map/index.js